export default __webpack_public_path__ + "static/media/hildebrandoneto.7d2d5aad.jpg";